<template>
  <div style="height: 30px;display: flex;align-items: center;" v-if="item.major!=null&&(item.major.sylflag!=null||item.major.majorRank!=null||item.major.xkPinggu!=null
  ||item.major.zdzylx!=null||item.major.majorSs!=null)" class="tagm">
    <el-tag class="mytag" type="danger" v-if="item.major.sylflag!=null">{{item.major.sylflag}}</el-tag>
    <el-tooltip
     v-if="item.major.majorRank!=null"
     class="item" effect="dark" :content="'专业排名 : '+item.major.majorRank" placement="top-start">
          <el-tag class="mytag">{{item.major.majorRank}}</el-tag>
    </el-tooltip>
    <el-tooltip
     v-if="item.major.xkPinggu!=null"
     class="item" effect="dark" :content="'第四次学科评估 : '+item.major.xkPinggu" placement="top-start">
          <el-tag class="mytag" type="danger">{{item.major.xkPinggu}}</el-tag>
    </el-tooltip>
    <el-tooltip
     v-if="item.major.zdzylx!=null"
     class="item" effect="dark" :content="'重点专业类型 : '+item.major.zdzylx" placement="top-start">
          <el-tag class="mytag" type="warning">{{item.major.zdzylx}}</el-tag>
    </el-tooltip>
    <el-tooltip
     v-if="item.major.majorSs!=null"
     class="item" effect="dark" :content="'硕士相关专业 : '+item.major.majorSs" placement="top-start">
          <el-tag class="mytag" type="success">{{item.major.ssType!=null?item.major.ssType:'硕'}}</el-tag>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: {

      item: {
        type: Object,
        default: {college:{}}
      }
    },
    data() {return{}},
    methods: {

    },
    mounted() {},
    created() {
    }
  };
</script>

<style scoped>
  .mytag {
    height: 18px;
    line-height: 16px;
    padding: 0 5px;
    margin-right: 5px;
  }
  .tagm .item{
    display: inline-block;
    padding: 0 5px;
    margin-right: 5px;
    border-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/imajor.vue